import { string, object, array } from 'yup';

import { PriceRange, PricePromotion, Prices } from './price';
import { Beneficiary, StaySchema, BeneficiarySchema } from '../common';
import { InvoicedStay } from '..';

export type BeneficiaryQuotationDetails = {
  age: number;
  days: number;
  priceRange: PriceRange;
};

export type BeneficiaryQuotation = {
  beneficiary: Beneficiary;
  price: number;
  details: BeneficiaryQuotationDetails;
  promotion: PricePromotion;
};

export type Quotation = {
  total: number;
  days: number;
  pricingPeriodStart: string;
  pricingPeriodEnd: string;
  details: Array<BeneficiaryQuotation>;
  zone: string;
};

export const StepSchema = StaySchema.concat(
  object({
    endDate: string().required()
  })
);
export type Step = {
  destination: string;
  startDate: string;
  endDate: string;
};
export const QuoteSchema = object({
  id: string(),
  beneficiaries: array()
    .of(BeneficiarySchema)
    .required()
    .default([]),
  steps: array()
    .of(StaySchema)
    .required()
    .default([])
});
export type Quote = {
  id: string;
  beneficiaries: Beneficiary[];
  steps: Step[];
  createdOn: Date;
};
export type PricedQuote = Quote & {
  total: number;
  days: number;
  prices: Prices;
  stepPrices: InvoicedStay[];
  expiresOn: Date;
};
